import { FC, ReactNode } from 'react'

import {
  Timeline as MantineTimeline,
  TimelineProps as MantineTimelineProps,
} from '@mantine/core'
import styled from 'styled-components'

const StyledTimeline = styled(MantineTimeline)`
  /* Здесь можно добавить кастомные стили */
`

export interface TimelineItemProps {
  title?: ReactNode
  children?: ReactNode
  bullet?: ReactNode
  active?: boolean
  color?: string
}

export interface TimelineProps extends Omit<MantineTimelineProps, 'children'> {
  children: ReactNode
  className?: string
}

export const Timeline: FC<TimelineProps> & {
  Item: FC<TimelineItemProps>
} = ({ children, className, ...props }) => {
  return (
    <StyledTimeline className={className} {...props}>
      {children}
    </StyledTimeline>
  )
}

Timeline.Item = MantineTimeline.Item as FC<TimelineItemProps>
